export const BRAND = {
  name: "Sylva King Plywood",
  shortName: "Sylva King",
  tagline: "Strength that rules — premium plywood, crafted with the spirit of a king.",
  whatsappNumber: "919408560325",
  whatsappDisplay: "+91 94085 60325",
  email: "info@sylvakingplywood.com",
  address: {
    line1: "Khajuri Road",
    line2: "Yamunanagar, Haryana – 135 001",
    full: "Khajuri Road, Yamunanagar, Haryana – 135 001",
  },
  // New transparent / clean PNG logo
  logoUrl:
    "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/7dirhtla_SYLVA%20KING%20PNG.png",
  images: {
    interior1:
      "https://images.unsplash.com/photo-1597072689227-8882273e8f6a?q=85&w=1500&auto=format&fit=crop",
    interior2:
      "https://images.unsplash.com/photo-1634822930432-0594057fdff2?q=85&w=1500&auto=format&fit=crop",
    craftsman:
      "https://images.unsplash.com/photo-1601058268499-e52658b8bb88?q=85&w=1500&auto=format&fit=crop",
    factory:
      "https://images.unsplash.com/photo-1565728744382-61accd4aa148?q=85&w=1500&auto=format&fit=crop",

    // Hero slide assets (1 → 2 → 3 as numbered by user)
    slide1:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/b72zrqe6_1.png",
    slide2:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/0b7kfs3c_2.png",
    slide3:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/tdnc8sxa_slider%20image.jpg",

    // King's Reserve "down" images (user-supplied)
    downImage1:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/fh3v0t4l_Down%20image%201.jpg",
    downImage2:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/iwyeya89_down%20image%202.jpeg",

    // Infrastructure image #3 (user-supplied)
    infrastructure3:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/lbshm1zi_inafastructure%20image%203.png",

    // About Us "Forest to Finish" infographic
    aboutUs:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/o1j7pta0_about%20us.png",

    // NEW branded product images uploaded by user
    strengthRulesPoster:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/7e8ezi7e_starangh%20of%20rules.png",
    commercialPlywood:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/crcu94nq_commercial%20plywood.png",
    waterproofPlywood:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/4k830d4x_waterproof%20plywood.png",
    calibratedPlywood:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/bartdwa7_calibrated%20plywood.png",

    // Infrastructure slider supporting images
    warehouse:
      "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/lcplfrvx_images.jfif",
  },
  heroSlides: [
    {
      img: "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/b72zrqe6_1.png",
      eyebrow: "Engineered with Precision",
      title: "Built where strength is forged.",
      caption:
        "State-of-the-art hot press machinery and precision engineering — every panel pressed to perfection.",
    },
    {
      img: "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/0b7kfs3c_2.png",
      eyebrow: "Designed for Living",
      title: "Spaces that age gracefully.",
      caption:
        "Premium plywood that turns kitchens, wardrobes and interiors into pieces of quiet luxury.",
    },
    {
      img: "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/tdnc8sxa_slider%20image.jpg",
      eyebrow: "Designed for Living",
      title: "Spaces that age gracefully.",
      caption:
        "Premium plywood that turns living rooms, wardrobes and interiors into pieces of quiet luxury.",
    },
  ],
  infrastructureSlides: [
    {
      img: "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/b72zrqe6_1.png",
      caption: "Modern hot press manufacturing",
    },
    {
      img: "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/lcplfrvx_images.jfif",
      caption: "Production floor",
    },
    {
      img: "https://customer-assets.emergentagent.com/job_sylva-quote/artifacts/lbshm1zi_inafastructure%20image%203.png",
      caption: "Precision calibration line",
    },
  ],
};
